import { NgModule } from '@angular/core'; 

import { CommonModule } from '@angular/common'; 

import { ForgotpasswordComponent } from './forgotpassword.component'; 

import { LoginComponent } from './login.component';
import { AuthRoutingModule } from './auth-routing.module'; 
import { FormsModule }   from '@angular/forms';

@NgModule({
  imports: [
    AuthRoutingModule ,
    FormsModule,
    CommonModule,

  ],
  declarations: [ LoginComponent, ForgotpasswordComponent ]
})
export class AuthModule { }
 


// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts